module.exports = __webpack_public_path__ + "staticcomp/img/share.cbe7d2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/4/share.jpg
// module id = G/j/
// module chunks = 39